import entity from '../../../models/cms/galleries'

export default [
  {
    path: '/galleries',
    meta: {
      entity,
      requiresPermissionTo: 'galleries',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: "galleries" */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/galleries/new',
    meta: {
      entity,
      requiresPermissionTo: 'galleries',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: "galleries" */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/galleries/:id',
    meta: {
      entity,
      requiresPermissionTo: 'galleries',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: "galleries" */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
